import React, { useContext, useCallback, useState } from 'react'

import { generateContext } from '@btime/react-contexts'

const { StateContext, ActionsContext, Provider } = generateContext()
export const useShareForm = () => useContext(StateContext)
export const useSetShareForm = () => useContext(ActionsContext).setState

export const useCloseShareForm = () => {
  const setForm = useSetShareForm()
  return useCallback(() => setForm({}), [setForm])
}

export const useOpenShareForm = () => {
  const setForm = useSetShareForm()
  return useCallback(form => setForm(form), [setForm])
}

const ShareFormContext = ({ ...props }) => {
  const [state, setState] = useState({})
  return <Provider state={state} actions={{ setState }} {...props} />
}

export default ShareFormContext
